import { Component, Input, OnInit } from '@angular/core';
import { HighlightNew } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-view-card',
  templateUrl: './sample-view-card.component.html',
  styleUrls: ['./sample-view-card.component.scss']
})
export class SampleViewCardComponent implements OnInit {

  @Input() block: HighlightNew = {} as HighlightNew;
  @Input() idx: number = 0;
  @Input() label_link: string = '';
  public stringTags: string = '';
  public isLinkEsternal: boolean = false;
  public domainWebsite = environment.urlApi;
  public imgPath = '';
  public image_alt = '';
  public objTitle = {
    title: '',
    hreflang: '',
    link: ''
  };

  constructor(
    private helperService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.objTitle = this.helperService.retriveLinkTagA(this.block.field_titolo, "a");
    this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.block.field_immagine, "src");
    this.image_alt = this.helperService.retrieveImage(this.block.field_immagine, "alt");
    this.isLinkEsternal = this.objTitle ? this.helperService.verifyLinkExternal(this.objTitle.link) : false;
    this.setLabelTags();
  }

  private setLabelTags() {
    let tags: string[] = [];
    if (this.block.field_tags) {
      this.block.field_tags.forEach((tag, idx) => {
        if (idx < 3) {
          tags.push(tag.name);
        }
      });
      if (this.block.field_tags.length > 3) {
        tags.push(`+${this.block.field_tags.length - 3}`)
      }
    }
    this.stringTags = tags.join(', ');
  }


}
